export default __webpack_public_path__ + "static/media/CNo.46-3.a45d00af.jpg";